import styled, { css } from 'styled-components';

export const StyledLabel = styled.label`
  display: block;
  width: max-content;
  font-size: 15px;
  line-height: 18px;
  font-weight: 400;
  color: var(--text-color-50);
  margin-bottom: 10px;


  pointer-events: ${({ $onlyRead }) => $onlyRead && 'none'};
  ${({ labelIcon }) =>
    labelIcon &&
    css`
      display: flex;
      align-items: center;
    `}
  ${({ $labelReverse }) =>
    $labelReverse &&
    css`
      position: relative;
      .label {
        flex-direction: row-reverse;
      }
    `};
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
    `}
  .label {
    display: flex;
    align-items: center;
    
  }
`;

export const RequiredAsterisk = styled.span`
  color: var(--danger);
  font-size: 14px;
`;
